import { useState } from "react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Sparkle, WhatsappLogo, Copy, Check, UsersThree } from "@phosphor-icons/react";
import InviteDialog from "@/components/InviteDialog";

export default function FoundingCoordinator({ inst }) {
  const [copied, setCopied] = useState(false);
  const origin = typeof window !== "undefined" ? window.location.origin : "https://alumnipulse.net";
  const url = `${origin}/institutions/${inst.id}`;
  const msg = `I'm starting our ${inst.name} alumni community on AlumniPulse — be one of the founding members and help us find our classmates & preserve our memories: ${url}`;

  const whatsapp = () => window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, "_blank", "noopener");
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); setCopied(true); toast.success("Invite link copied"); setTimeout(() => setCopied(false), 2000); }
    catch { toast.error("Copy failed — select the link manually"); }
  };

  return (
    <Card className="relative mb-5 overflow-hidden border-secondary/30 bg-gradient-to-br from-accent/60 to-background p-6 shadow-sm" data-testid="founding-coordinator">
      <div className="flex items-start gap-3">
        <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-secondary text-secondary-foreground"><Sparkle size={22} weight="fill" /></span>
        <div className="min-w-0">
          <p className="overline text-secondary mb-1">Founding Alumni Coordinator</p>
          <h2 className="font-heading text-xl font-medium leading-tight">Be the first — start your {inst.name} alumni community</h2>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-muted-foreground">
            No one from {inst.name} has joined yet. Be the founding member: create your class or batch group, then invite your classmates. It only takes a few people to bring a whole community back together.
          </p>
          <div className="mt-5 flex flex-wrap gap-2.5">
            <Link to="/groups"><Button className="rounded-full gap-1.5" data-testid="founding-create-group"><UsersThree size={16} /> Create the first group</Button></Link>
            <Button variant="outline" className="rounded-full gap-1.5 border-[#25D366]/40 text-[#128C7E] hover:bg-[#25D366]/10" onClick={whatsapp} data-testid="founding-whatsapp">
              <WhatsappLogo size={16} weight="fill" /> Invite on WhatsApp
            </Button>
            <Button variant="outline" className="rounded-full gap-1.5" onClick={copy} data-testid="founding-copy-link">
              {copied ? <Check size={16} /> : <Copy size={16} />} {copied ? "Copied" : "Copy invite link"}
            </Button>
            <InviteDialog type="institution" id={inst.id} label="Get invite card" variant="outline" size="sm" />
          </div>
          <p className="mt-3 text-xs text-muted-foreground">Free • Invite by WhatsApp, email or a shareable class card • You'll be recognised as a Founding Contributor.</p>
        </div>
      </div>
    </Card>
  );
}
